import React, { useState, useEffect } from 'react';
import '../../styles/republic-day.css';

/**
 * Republic Day Banner component - displays a dismissible tricolor banner
 * Uses localStorage to remember dismissal
 */
const TricolorBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has dismissed banner
    const isDismissed = localStorage.getItem('republic-day-banner-dismissed');
    if (!isDismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem('republic-day-banner-dismissed', 'true');
  };

  if (!isVisible) return null;

  return (
    <div className="republic-day-banner" role="banner">
      <div className="republic-day-banner-content">
        <span className="republic-day-icon">🇮🇳</span>
        <span className="republic-day-text">
          Jai Hind! Celebrating the spirit of India's Republic Day!
        </span>
        <span className="republic-day-icon">🎆</span>
      </div>
      <button
        onClick={handleDismiss}
        className="republic-day-banner-close"
        aria-label="Close banner"
      >
        ✕
      </button>
    </div>
  );
};

export default TricolorBanner;
